import { Injectable } from "@angular/core";
import { Action, createSelector, State, StateContext } from "@ngxs/store";
import { IPagination } from "src/app/model/IPagination";
import {
	StoredPaginationResetAction,
	StoredPaginationStoreAction,
} from "./stored-pagination.actions";

export class StoredPaginationStateModel {
	public pagination: IPagination[];
}
const paginationDefault: IPagination = {
	type: "",
	searchCriteria: "",
	direction: "older",
	siteID: null,
	lastRequestedID: `${Number.MAX_SAFE_INTEGER}`,
	limit: 5,
	statuses: [],
	currentPage: 1,
	totalResults: 0,
	isArchived: false,
};

const defaults = {
	pagination: [],
};

@State<StoredPaginationStateModel>({
	name: "storedPagination",
	defaults,
})
@Injectable()
export class StoredPaginationState {
	static pagination(type: string) {
		return createSelector(
			[StoredPaginationState],
			(state: StoredPaginationStateModel) => {
				const [pagination] = state.pagination.filter((i) => i.type === type);
				return pagination ?? { ...paginationDefault, type: type };
			}
		);
	}

	@Action(StoredPaginationStoreAction)
	StoredPaginationStoreAction(
		{ getState, setState }: StateContext<StoredPaginationStateModel>,
		{ payload }: StoredPaginationStoreAction
	) {
		const state = getState();
		const paginationArray = [...state.pagination];

		const currentStateIndex = paginationArray.findIndex(
			(i) => i.type === payload.type
		);
		if (currentStateIndex === -1) {
			paginationArray.push({
				...paginationDefault,
				...payload,
			});
		} else {
			paginationArray[currentStateIndex] = {
				...paginationArray[currentStateIndex],
				...payload,
			};
		}

		setState({ pagination: paginationArray });
	}

	@Action(StoredPaginationResetAction)
	StoredPaginationResetAction(
		{ getState, setState }: StateContext<StoredPaginationStateModel>,
		{ payload }: StoredPaginationResetAction
	) {
		const state = getState();
		const paginationArray = [...state.pagination];

		const [pagination] = state.pagination.filter((i) => i.type === payload);
		if (pagination) {
			const currentStateIndex = paginationArray.indexOf(pagination) - 1;
			delete paginationArray[currentStateIndex];
			setState({ pagination: paginationArray });
		}
	}
}
